import { BatchReports } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

export const CreateBatchReportRequest = Simple({
  id: '85807FA7-5C65-4B86-8E23-CE17F47F1248',
  action: 'Create',
  object: 'Batch Report',
  page: BatchReports,
})
